export default __webpack_public_path__ + "static/media/btc.9bc86613.png";